<div class="min-h-screen flex flex-col items-center justify-center bg-gray-50 text-center px-6">
  
  <h1 class="text-9xl font-extrabold text-gray-300 select-none">
    404
  </h1>

  <h2 class="mt-4 text-3xl font-semibold text-gray-800">
    Page Not Found
  </h2>

  <p class="mt-2 text-gray-600 max-w-md">
    Oops! The page you're looking for doesn’t exist or has been moved.
  </p>

  <!-- <div class="mt-8">
    <a 
      routerLink="/"
      class="px-6 py-3 bg-blue-600 text-white rounded-xl shadow hover:bg-blue-700 transition-all">
      Go Back Home
    </a>
  </div> -->

</div>
